"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  GraphStats: ['graph-stats', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,11.75h3.5a1.5,1.5,0,0,0,1.385-.923l2.6-6.115a.75.75,0,0,1,1.4.051l4.734,14.725a.75.75,0,0,0,1.4.051l2.595-6.866a1.5,1.5,0,0,1,1.385-.923h3.5']],
  GraphStatsSquare: ['graph-stats-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M3.75,12.75h3L9.01,7.1a.749.749,0,0,1,1.4.029l3.292,9.325a.75.75,0,0,0,1.358.123L17.25,12.75h3']],
  GraphStatsCircle: ['graph-stats-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M3.75,12.75h3L9.01,7.1a.749.749,0,0,1,1.4.029l3.292,9.325a.75.75,0,0,0,1.358.123L17.25,12.75h3']],
  GraphStatsDescend: ['graph-stats-descend', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 11.25L23.25 18 16.5 18', 'M23.25,18l-7.939-7.939a1.5,1.5,0,0,0-2.122,0l-3.128,3.128a1.5,1.5,0,0,1-2.122,0L.75,6']],
  GraphStatsAscend: ['graph-stats-ascend', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 12.75L23.25 6 16.5 6', 'M23.25,6l-7.939,7.939a1.5,1.5,0,0,1-2.122,0l-3.128-3.128a1.5,1.5,0,0,0-2.122,0L.75,18']]
};
exports["default"] = _default;